import ReviewCard from './ReviewCard';
import LocationInfo from './LocationInfo';

export default {
  ReviewCard,
  LocationInfo,
};
